// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

interface Props {
  loading: boolean;
  onReset: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export default class ButtonsForm extends React.Component<Props> {
  public constructor(props: Props) {
    super(props);
    this.state = {};
  }

  public render(): JSX.Element {
    const { loading, onReset } = this.props;

    return (
      <fieldset>
        <footer>
          <div className="text-right">
            <label>
              <i>This field is required (*)</i>
            </label>
          </div>
          <div className="text-right">
            {loading && (
              <img className="loading-wdna" alt="loading" src="assets/img/loading-wdna.gif" />
            )}
            <button type="submit" className="btn btn-primary">
              Save
            </button>
            &nbsp;&nbsp;
            <button type="button" onClick={onReset} className="btn btn-primary">
              Reset
            </button>
          </div>
        </footer>
      </fieldset>
    );
  }
}
